import { TotpSessionKey, UAuthTokenKey } from '../Constants'
import { removeSessionStorage } from './Session'

//logout sessions and other before logout
export const ClearSessionOnSignOut = () => {
  removeSessionStorage(TotpSessionKey)
  removeSessionStorage(UAuthTokenKey)
}
